var De = Object.defineProperty, Pe = Object.defineProperties;
var Be = Object.getOwnPropertyDescriptors;
var Q = Object.getOwnPropertySymbols;
var me = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var de = (o, c, a) => c in o ? De(o, c, { enumerable: !0, configurable: !0, writable: !0, value: a }) : o[c] = a, N = (o, c) => {
  for (var a in c || (c = {}))
    me.call(c, a) && de(o, a, c[a]);
  if (Q)
    for (var a of Q(c))
      ue.call(c, a) && de(o, a, c[a]);
  return o;
}, pe = (o, c) => Pe(o, Be(c));
var he = (o, c) => {
  var a = {};
  for (var u in o)
    me.call(o, u) && c.indexOf(u) < 0 && (a[u] = o[u]);
  if (o != null && Q)
    for (var u of Q(o))
      c.indexOf(u) < 0 && ue.call(o, u) && (a[u] = o[u]);
  return a;
};
var R = (o, c, a) => new Promise((u, T) => {
  var U = (f) => {
    try {
      D(a.next(f));
    } catch (b) {
      T(b);
    }
  }, s = (f) => {
    try {
      D(a.throw(f));
    } catch (b) {
      T(b);
    }
  }, D = (f) => f.done ? u(f.value) : Promise.resolve(f.value).then(U, s);
  D((a = a.apply(o, c)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postRequestCheckByParams as Le } from "../../../../request/unifiedcheck/universalCheckApi/requestCheckByParams/post.js";
import { getSelectPlate as Me } from "../../../../request/bsplatform/external/commodity/selectPlate/get.js";
import { postQueryCommodityByPageFromES as je } from "../../../../request/bsplatform/commodity/queryCommodityByPageFromES/post.js";
import { useLanguage as we } from "../../../../utils/useLanguage.js";
import Ve from "./workForm.vue.js";
import ge from "./banjianForm.js";
import m from "./banjianFormComps.js";
import Fe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/alert/src/Alert.js";
import { defineComponent as Re, useTemplateRef as Ie, watch as te, computed as I, openBlock as oe, createElementBlock as fe, createElementVNode as W, createVNode as V, withCtx as O, createBlock as We, createTextVNode as ye, Fragment as Oe, nextTick as ze } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Ue } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as C, unref as g } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Ge from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import { toDisplayString as z } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import Ae from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ce from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import qe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Qe = { class: "commodity-name" }, Xe = {
  key: 1,
  class: "tw:text-center tw:py-4"
}, Ze = { class: "tw:ml-2" }, He = { class: "tw:!flex tw:!justify-center tw:!mt-[10px]" }, ht = /* @__PURE__ */ Re({
  name: "BanjianCustom",
  inheritAttrs: !1,
  __name: "banjian",
  props: {
    options: {},
    params: {},
    locale: {}
  },
  emits: ["onSuccess", "hide-dialog"],
  setup(o, { expose: c, emit: a }) {
    const { i18n: u } = we(), { t: T } = u.global, U = Ie("configurationGoodsContainer"), s = o;
    te(
      () => s.locale,
      (e) => {
        u.global.locale.value = e || "zh-CN";
      },
      { immediate: !0 }
    );
    const D = a, f = Ue(), b = C(""), G = C(""), X = C(""), A = C(!0), n = C(new ge()), P = C(m.components), ae = C({}), Z = C({}), H = C(null), ke = C(N({}, s.options));
    let J = !1;
    const se = I(() => {
      const { edgeThicknessThick: e, thickEdgeSysCode: t, thickEdgeCode: r, thickEdgeSalesCode: i } = s.options;
      return !!(e && t && r && i);
    }), ce = I(() => {
      const { edgeThicknessThin: e, thinEdgeSysCode: t, thinEdgeCode: r, thinEdgeSalesCode: i } = s.options;
      return !!(e && t && r && i);
    }), ve = (e) => R(this, null, function* () {
      if (!J && !ne(n.value, e))
        try {
          J = !0, n.value = N({}, e), yield ze();
        } finally {
          setTimeout(() => {
            J = !1;
          }, 0);
        }
    }), ne = (e, t) => {
      if (e === t)
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      const r = Object.keys(e), i = Object.keys(t);
      if (r.length !== i.length)
        return !1;
      for (const l of r)
        if (!i.includes(l) || !ne(e[l], t[l]))
          return !1;
      return !0;
    }, re = I(() => {
      const { edgeThicknessThick: e, edgeThicknessThin: t } = s.options, r = parseFloat(e) || 0, i = parseFloat(t) || 0;
      return [0, r, i][m.edgeTypes.indexOf(n.value.edgeType)];
    }), Te = I(() => P.value && P.value.length > 0 && P.value.some((e) => e && e.attr));
    I(() => !s.options.fcolorSalesCode);
    const be = () => {
      const e = ae.value[n.value.productThickness];
      if (!e)
        return;
      const { id: t, name: r, no: i, attributes: l } = e;
      b.value = t || "", G.value = r || "", X.value = i || "";
      const y = N({}, n.value);
      l && l.filter(
        ({ attributeCode: p }) => ["productLength", "productWidth"].includes(p)
      ).forEach(
        ({
          attributeCode: p,
          attributeValues: h
        }) => {
          h && h.length > 0 && (y[p] = parseFloat(h[0]) || 0);
        }
      ), y.edgeType = "无封边", n.value = y, l && l.filter(
        ({ attributeCode: p }) => [
          "edgeThicknessThick",
          "edgeThicknessThin",
          "thickEdgeSysCode",
          "thickEdgeCode",
          "thickEdgeSalesCode",
          "thinEdgeSysCode",
          "thinEdgeCode",
          "thinEdgeSalesCode"
        ].includes(p)
      ).forEach(
        ({
          attributeCode: p,
          attributeValues: h
        }) => {
          s.options && (ke.value[p] = (h || []).join(","));
        }
      ), m.hasThickEdge = se.value, m.hasThinEdge = ce.value, P.value = m.components;
    }, K = () => {
      A.value = !1, Se();
    }, Ee = () => {
      const e = ["edge1SysCode", "edge2SysCode", "edge3SysCode", "edge4SysCode"], t = ["edge1Code", "edge2Code", "edge3Code", "edge4Code"], r = [
        "edge1SalesCode",
        "edge2SalesCode",
        "edge3SalesCode",
        "edge4SalesCode"
      ], i = [
        "edge1Thickness",
        "edge2Thickness",
        "edge3Thickness",
        "edge4Thickness"
      ], l = m.edgeTypes.indexOf(n.value.edgeType), {
        edgeThicknessThick: y,
        edgeThicknessThin: p,
        thickEdgeSysCode: h,
        thickEdgeCode: B,
        thickEdgeSalesCode: L,
        thinEdgeSysCode: d,
        thinEdgeCode: E,
        thinEdgeSalesCode: M
      } = s.options, _ = parseFloat(y) || 0, j = parseFloat(p) || 0, w = [null, h, d][l], Y = [null, B, E][l], $ = [null, L, M][l], ee = [0, _, j][l], x = {};
      return t.forEach((k) => {
        x[k] = Y || null;
      }), e.forEach((k) => {
        x[k] = w || null;
      }), r.forEach((k) => {
        x[k] = $ || null;
      }), i.forEach((k) => {
        x[k] = ee;
      }), x;
    }, Se = () => {
      n.value = new ge(), D("hide-dialog");
    }, Ne = () => R(this, null, function* () {
      H.value && H.value.submit().then((e) => R(this, null, function* () {
        var ie;
        console.log("校验通过了");
        const {
          editRemark: t,
          isProduce: r,
          isCut: i,
          productionAttr: l,
          specificationModel: y,
          materialCode: p,
          materialClassification: h,
          topMaterialName: B,
          topSalesCode: L,
          topMaterialCode: d,
          topMaterialClassification: E,
          bottomMaterialName: M,
          bottomSalesCode: _,
          bottomMaterialCode: j,
          bottomMaterialClassification: w,
          pricingCode: Y,
          editRemark1: $,
          color: ee,
          oldMaterialName: x,
          materialTexture: k,
          veneerPattern: _e
        } = s.options, q = pe(N(N(N({}, n.value), Ee()), Z.value[n.value.plateType]), {
          cutLength: n.value.productLength - 2 * re.value,
          cutWidth: n.value.productWidth - 2 * re.value,
          cutThickness: n.value.productThickness,
          editRemark: t,
          isProduce: r,
          isCut: i,
          productionAttr: l,
          specificationModel: y,
          materialCode: p,
          materialClassification: h,
          materialTexture: Number(k) || 0,
          topMaterialName: B,
          topSalesCode: L,
          topMaterialCode: d,
          topMaterialClassification: E,
          bottomMaterialName: M,
          bottomSalesCode: _,
          bottomMaterialCode: j,
          bottomMaterialClassification: w,
          pricingCode: Y,
          editRemark1: $,
          color: ee,
          oldMaterialName: x,
          veneerPattern: Number(_e) || 0,
          entrance: "新增板件"
        }), { componentClassification: le } = s.options[13] || {};
        le && Object.assign(q, { componentClassification: le });
        const F = N({
          commodityId: s.options.commodityId,
          code: X.value
        }, q);
        Object.keys(F).forEach(
          (v) => typeof F[v] == "number" && (F[v] = F[v].toString())
        );
        try {
          const v = yield Le({
            checkTypes: "CG_XD",
            checkDatas: {
              commodityList: [F],
              edit: Object.keys(q)
            }
          }), xe = (v == null ? void 0 : v.taskInfoVOList) || [], [S] = xe;
          S != null && S.checkDataResultVO && ((ie = S == null ? void 0 : S.checkDataResultVO) != null && ie.resultLevel) ? S.checkDataResultVO.resultDesc ? f.error(S.checkDataResultVO.resultDesc) : f.error("校验失败") : D(
            "onSuccess",
            Object.assign(q, {
              commodityId: b.value,
              commodityName: G.value
            }),
            b.value !== s.options.commodityId ? ae.value[n.value.productThickness] : null
          );
        } catch (v) {
          console.error("请求失败", v);
        }
      })).catch((e) => {
        console.log("校验没通过", e);
      });
    });
    return te(
      () => s.options,
      (e) => R(this, null, function* () {
        var r, i, l, y, p, h, B, L;
        b.value = e.commodityId || "", G.value = e.commodityName || "", X.value = e.code || "", m.isQuick = e.classify1 === "快速定制品", m.productLength = ((r = e[13]) == null ? void 0 : r.productLength) || 0, typeof e.productLength == "string" && (e.productLength = (i = m.productLength) != null ? i : void 0), m.productWidth = ((l = e[13]) == null ? void 0 : l.productWidth) || 0, typeof e.productWidth == "string" && (e.productWidth = (y = m.productWidth) != null ? y : void 0), m.productThickness = ((p = e[13]) == null ? void 0 : p.productThickness) || 0, typeof e.productThickness == "string" && (e.productThickness = (h = m.productThickness) != null ? h : void 0), Object.keys(n.value).forEach((d) => {
          Reflect.has(e, d) && (n.value[d] = e[d]);
        });
        const t = {
          brand: s.params.brand,
          category: s.params.category,
          applicableProductChannels: s.params.applicableProductChannels && s.params.applicableProductChannels.length ? s.params.applicableProductChannels : void 0,
          marketClassify: s.params.marketClassify
        };
        if (!t.brand || !t.category || !t.applicableProductChannels || !t.marketClassify)
          try {
            const d = yield je({
              productType: "CUSTOMIZED",
              id: Number(e.commodityId) || void 0
            }), [
              E = {
                applicableBrandCategorys: [],
                applicableProductChannels: [],
                marketClassify: ""
              }
            ] = (B = d == null ? void 0 : d.records) != null ? B : [];
            console.log("commodity", E);
            const {
              applicableBrandCategorys: M,
              applicableProductChannels: _,
              marketClassify: j
            } = E;
            (!t.brand || !t.category) && Object.assign(t, { brandCategoryCon: M }), t.applicableProductChannels || Object.assign(t, { applicableProductChannels: _ }), t.marketClassify || Object.assign(t, { marketClassify: j });
          } catch (d) {
            console.error("获取商品信息失败", d);
          }
        console.log("searchParams", t);
        try {
          const { data: d } = yield Me({
            category: t.category || t.brandCategoryCon && ((L = t.brandCategoryCon[0]) == null ? void 0 : L.category) || ""
          });
          Z.value = Object.fromEntries(
            (d || [
              {
                id: "1",
                plateType: "封板",
                componentName: "封板（仅用遗留单）",
                componentClassification: "112_001",
                componentDataType: "3"
              }
            ]).map((j) => {
              var w = j, { plateType: E, id: M } = w, _ = he(w, ["plateType", "id"]);
              return [E, _];
            })
          ), m.plateTypes = Object.keys(Z.value), m.hasThickEdge = se.value, m.hasThinEdge = ce.value, P.value = m.components;
        } catch (d) {
          console.error("获取板件类型失败", d);
        }
      }),
      { immediate: !0, deep: !0 }
    ), te(() => n.value.productThickness, be), c({
      formData: n,
      isShowDialog: A,
      onClose: K
    }), (e, t) => (oe(), fe(Oe, null, [
      W("div", {
        ref_key: "configurationGoodsContainer",
        ref: U
      }, null, 512),
      V(g(qe), {
        bordered: "",
        show: A.value,
        "onUpdate:show": t[0] || (t[0] = (r) => A.value = r),
        "mask-closable": !1,
        to: U.value || "body"
      }, {
        default: O(() => [
          V(g(Ge), {
            class: "tw:!w-[480px] tw:!box-border tw:!text-left",
            title: g(T)("定制板件"),
            bordered: !1,
            role: "dialog",
            closable: "",
            "header-class": "tw:!text-center",
            onClose: K
          }, {
            default: O(() => [
              W("h3", Qe, z(G.value), 1),
              Te.value ? (oe(), We(Ve, {
                key: 0,
                formData: n.value,
                components: P.value,
                "label-width": "6em",
                ref_key: "form",
                ref: H,
                "no-control": "",
                "onUpdate:formData": ve
              }, null, 8, ["formData", "components"])) : (oe(), fe("div", Xe, [
                V(g(Ae), { size: "small" }),
                W("span", Ze, z(g(T)("加载中")), 1)
              ])),
              V(g(Fe), {
                type: "error",
                closable: !1,
                size: "small",
                class: "tw:!w-[440px]"
              }, {
                default: O(() => [
                  W("span", null, z(g(T)("注意：橱柜、衣柜、卫浴有纹路板件纹路方向平行于长度方向")), 1)
                ]),
                _: 1
              }),
              W("div", He, [
                V(g(Ce), {
                  type: "primary",
                  onClick: Ne,
                  size: "small"
                }, {
                  default: O(() => [
                    ye(z(g(T)("确定")), 1)
                  ]),
                  _: 1
                }),
                V(g(Ce), {
                  type: "primary",
                  onClick: K,
                  size: "small",
                  class: "tw:!ml-5"
                }, {
                  default: O(() => [
                    ye(z(g(T)("取消")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ht as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/banjian.vue2.js
// module id = 1244
// module chunks = 67